import SharedSurveyProgressBadge from './shared-survey-progress-badge';
import SharedSurveyProgressRing from './shared-survey-progress-ring';

interface Props {
  estimatedTotalTimeInSeconds: number;
  progress: number;
  size?: number;
  strokeWidth?: number;
}

/**
 * Responsive progress timer that shows:
 * - Ring on desktop (sm and up)
 * - Badge on mobile (below sm)
 */
export default function SharedSurveyProgressTimer({
  estimatedTotalTimeInSeconds,
  progress,
  size = 40,
  strokeWidth = 4,
}: Props) {
  return (
    <>
      <SharedSurveyProgressRing
        estimatedTotalTimeInSeconds={estimatedTotalTimeInSeconds}
        progress={progress}
        size={size}
        strokeWidth={strokeWidth}
        className='hidden sm:flex'
      />
      <SharedSurveyProgressBadge
        estimatedTotalTimeInSeconds={estimatedTotalTimeInSeconds}
        progress={progress}
        className='flex sm:hidden'
      />
    </>
  );
}
